import { fetchRatioSyncDiffApi } from './ratioSync'
import { ratioToPriceFactor } from './modelPricing'

/** models.dev 作为 ratio_sync 的上游预设（后端负责拉取，避免浏览器跨域） */
const MODELS_DEV_UPSTREAM = {
  id: -101,
  name: 'models.dev',
  base_url: 'https://models.dev',
  endpoint: 'https://models.dev/api.json',
}

export interface OfficialPricing {
  /** 官方输入价（美元 / 百万 token） */
  inputPerMillion: number | null
  /** 官方输出价 */
  outputPerMillion: number | null
  /** 官方缓存命中价 */
  cacheReadPerMillion: number | null
  /** 官方按次固定价（如果有） */
  fixedPrice: number | null
  /** 数据来源标注 */
  source: string
}

const num = (v: unknown): number | null => {
  if (v === null || v === undefined || v === '') return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

/**
 * 拉取某个模型的官方价格（models.dev）。
 * 走 /api/ratio_sync/fetch + include_unchanged，即使与我们当前配置一致也能取到。
 */
export async function fetchOfficialPricing(
  model: string,
  timeout = 30
): Promise<OfficialPricing | null> {
  const result = await fetchRatioSyncDiffApi({
    upstreams: [MODELS_DEV_UPSTREAM],
    timeout,
    include_unchanged: true,
  })
  const row = result.prices?.[model]
  if (!row?.upstreams) return null
  // 后端把上游标记成 "name(id)"，例如 models.dev(-101)，所以按前缀匹配
  const entry = Object.entries(row.upstreams).find(([key]) =>
    key.startsWith(MODELS_DEV_UPSTREAM.name)
  )
  const upstream = entry?.[1]
  if (!upstream) return null

  const factor = ratioToPriceFactor()
  const modelRatio = num(upstream['model_ratio'])
  const completionRatio = num(upstream['completion_ratio'])
  const cacheRatio = num(upstream['cache_ratio'])
  const modelPrice = num(upstream['model_price'])

  const inputPerMillion = modelRatio === null ? null : modelRatio * factor
  return {
    inputPerMillion,
    outputPerMillion:
      inputPerMillion !== null && completionRatio !== null
        ? inputPerMillion * completionRatio
        : null,
    cacheReadPerMillion:
      inputPerMillion !== null && cacheRatio !== null ? inputPerMillion * cacheRatio : null,
    fixedPrice: modelPrice,
    source: MODELS_DEV_UPSTREAM.name,
  }
}
